import { getAssistantIllustration } from '@/hooks/useAssistantIllustration'

import type { MessageSize, StatusMessageType, StatusVisual } from './types/StatusMessageTypes'

export interface StatusPreset {
    visual: () => StatusVisual
}

const assistantVisual = (): StatusVisual => ({
    kind: 'image',
    src: getAssistantIllustration(),
    background: 'var(--g-blue-90)',
    rounded: true,
})

// One entry per type: a new type is a new entry here, nothing else changes
export const STATUS_PRESETS: Record<StatusMessageType, StatusPreset> = {
    'thinking': { visual: assistantVisual },
    'solution-found': { visual: assistantVisual },
    'browse-local-database': { visual: () => ({ kind: 'icon', name: 'industry-search' }) },
    'browse-global-database': { visual: () => ({ kind: 'icon', name: 'globe-search' }) },
}

export const resolveStatusVisual = (type?: StatusMessageType, visual?: StatusVisual): StatusVisual | undefined =>
    visual ?? (type ? STATUS_PRESETS[type].visual() : undefined)

// Messages of a type follow the screen; the others are small unless they say otherwise
export const resolveMessageSize = (type: StatusMessageType | undefined, isMobile: boolean, messageSize?: MessageSize): MessageSize =>
    messageSize ?? (type && !isMobile ? 'normal' : 'small')
